import { initialState } from './initialState';
import { usersReducer} from './users/usersReducer';


export const rootReducer = (state = initialState, action) => {
    return {
        users: usersReducer(state.users, action),
    }
}
